import { Version } from '@angular/core';


export const VERSION = new Version('{{VERSION}}');
